import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import useLanguageChange from "../../../../hooks/useLanguageChange";
import { GLOBAL_MEETING_DATA, PublicVariables } from "../../../../constants/PublicVariables";
import { ARTICLES_NUMBER, SOLUTION_ARTICLE_LINK } from "../../../../constants/LDConstants";

const OnVideoLocationView = () => {
    const localisedValues = useLanguageChange();
    const { isLocationOnVideoIsVisible, locationOnVideoDetails } = useSelector((state) => state.commonReducer);
    const isStreamingUserLocationBlocked = isEmpty(locationOnVideoDetails);

    const openLinkInNewTab = (link) => {
        if (link) window.open(link, "_blank");
    };

    const handleClickOnResetGuide = () => {
        const helpArticleLink = SOLUTION_ARTICLE_LINK;
        const link = helpArticleLink + ARTICLES_NUMBER.LOCATION_PERMISSION_ARTICLES_NUMBER;
        openLinkInNewTab(link);
    };

    return (
        <>
            {isLocationOnVideoIsVisible && GLOBAL_MEETING_DATA.isAgent && (
                <div className='video-participant-location' data-testid='participant-location'>
                    <div className='video-participant-location-in'>
                        {!isStreamingUserLocationBlocked ? (
                            <div className='for-left-label hide-mob-label'>
                                <span className='for-name'>{locationOnVideoDetails.participantName}</span>
                                {!PublicVariables.isMobile ? localisedValues["location_colon"] : ""}
                            </div>
                        ) : (
                            <div className='for-left-label'>{localisedValues["location_blocked_by_user"] + "."}</div>
                        )}

                        <div className='location-link custom-tooltip top-tooltip center-tooltip tooltip-auto-width m-hide'>
                            {!isStreamingUserLocationBlocked ? (
                                <button className='btn' onClick={() => openLinkInNewTab(locationOnVideoDetails.googleMapLink)}>
                                    <span className='for-text'>{`${locationOnVideoDetails.latitude}, ${locationOnVideoDetails.longitude}`}</span>
                                    <span className='for-icon icon-new-tab'></span>
                                </button>
                            ) : (
                                <button className='btn' onClick={handleClickOnResetGuide}>
                                    <span className='for-text'>{localisedValues["reset_guide"]}</span>
                                </button>
                            )}

                            {!isStreamingUserLocationBlocked && (
                                <div className='custom-tooltip-content text-nowrap'>
                                    <div className='custom-tooltip-in'>
                                        <p>{localisedValues["open_in_google_maps"]}</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default OnVideoLocationView;
